import {createRootRouteWithContext, Outlet} from "@tanstack/react-router";
import {TanStackRouterDevtools} from "@tanstack/react-router-devtools";
import {TProfile, TUser} from "@zeg/instant/types";

interface RootContext {
  auth: {user: TUser; profiles: TProfile[]; isProfilesReady: boolean};
}

export const Route = createRootRouteWithContext<RootContext>()({
  component: () => {
    return (
      <>
        <Outlet />
        <TanStackRouterDevtools position="bottom-right" />
      </>
    );
  },
});
